import React, { useState } from "react";
import Logo from "../Logo/Logo";
import { Link } from "react-router-dom";
import Zonas from "../Delivery/Zonas";
import OrderTracker from "../OrderTracker/OrderTracker";
import "../Welcome/Welcome.css";

const NavBar = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div>
      <nav className="navbar navbar-expand-lg custom-navbar">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <Logo />
          </Link>
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/home">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={"/category/combos"}>
                  Combos
                </Link>
              </li>
              <li className="nav-item">
                <span className="nav-link responsive" style={{ cursor:"pointer"}}>
                  <Zonas zona={"Zona de delivery"} />
                </span>
              </li>
              <li className="nav-item responsive">
                {/* 🔥 Botón de pedido sin icono */}
                <button className="nav-link track-order" onClick={handleOpen}>
                  Tu pedido
                </button>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link social-icon"
                  to="https://www.instagram.com/pedirnuncafuetanfacilok/?hl=es"
                  target="_blank"
                >
                  <i className="bi bi-instagram"></i>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link settings-icon" to={"/login"}>
                  <i className="bi bi-gear"></i>
                </Link>
              </li>
            </ul>
            <b className="app-title">
              Pedir Nunca Fue Tan Fácil App
            </b>
          </div>
        </div>
      </nav>

      {/* 🔥 Modal para rastrear pedidos */}
      <OrderTracker show={showModal} handleClose={handleClose} />
    </div>
  );
};

export default NavBar;
